import { render, staticRenderFns } from "./ngo-about.vue?vue&type=template&id=2adbf550&scoped=true&"
import script from "./ngo-about.vue?vue&type=script&lang=js&"
export * from "./ngo-about.vue?vue&type=script&lang=js&"
import style0 from "./ngo-about.vue?vue&type=style&index=0&id=2adbf550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adbf550",
  null
  
)

export default component.exports